import clsx from "clsx";
import { FC } from "react";
import Badge from "../Badge";
import { Locale } from "../lib/i18n";
import { offerLabels } from "../lib/labels";

interface OfferBadgesProps {
  addPlaceholder?: boolean;
  isLowestInterestRate?: boolean;
  isLowestMonthlyInstallment?: boolean;
  locale: Locale;
}

const OfferBadges: FC<OfferBadgesProps> = ({
  locale,
  addPlaceholder,
  isLowestInterestRate,
  isLowestMonthlyInstallment,
}) => {
  const labels = offerLabels[locale];

  return (
    <span
      className={clsx("flex gap-xs items-center justify-center mb-2xs", {
        "h-[26px]": addPlaceholder,
      })}
    >
      {isLowestInterestRate && !isLowestMonthlyInstallment && (
        <Badge color="info" iconStart="RocketTwo">
          {labels.lowestInterestRate}
        </Badge>
      )}
      {isLowestMonthlyInstallment && !isLowestInterestRate && (
        <Badge color="purple" iconStart="Diamond">
          {labels.lowestMonthlyInstallment}
        </Badge>
      )}
      {isLowestMonthlyInstallment && isLowestInterestRate && (
        <Badge color="purple" iconStart="Diamond">
          {labels.lowestBaseRate}
        </Badge>
      )}
    </span>
  );
};

export default OfferBadges;
